import { ReactElement } from 'react'
import styled from 'styled-components'

import { CAREERS_ROUTE } from '@/utils/routes'

import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { ImageTitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'

export const CareersPage = () => {
  return (
    <CareersMain>
      <LinkCardList>
        {CAREERS_ROUTE.subdirectories.map(
          ({ imagePath, path, name, ...rest }) => (
            <LinkCard
              imgPath={imagePath}
              key={path}
              link={path}
              title={name}
              {...rest}
            />
          )
        )}
      </LinkCardList>
    </CareersMain>
  )
}
CareersPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '採用情報', path: '' },
  ]

  return (
    <>
      <Head
        title="採用情報"
        description="トライアルホールディングスの採用情報を掲載しています。トライアルグループではテクノロジーと、人の経験知で、世界のリアルコマースを変える仲間を募集しています。"
        ogp={{ url: 'careers/' }}
      />
      <ImageTitleLayout
        title="Careers"
        subTitle="採用情報"
        imgUrl="/images/top-careers.webp"
        breadCrumbs={breadCrumbs}
        isRequiredBackground={false}
      >
        {page}
      </ImageTitleLayout>
    </>
  )
}

const CareersMain = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 96px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 80px;
  }
`
